<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';

    import { week } from '../utilities/mockWeekSchedule';
    import { WeekSchedule } from '../utilities/WeekSchedule';
    import {
        TacticalPlanApi,
        type TacticalPlanResponseType,
    } from '../components/TacticalPlan/TacticalPlanApi';
    import { api } from '../../stores/api';
    import { debug } from '../../stores/store';
    import IconRadioButtonChecked from './Icons/IconRadioButtonChecked.svelte';
    import IconRadioButtonUnchecked from './Icons/IconRadioButtonUnchecked.svelte';
    import { TacticalPlan } from '../components/TacticalPlan/TacticalPlan';
    import IconPending from './Icons/IconPending.svelte';
    import Opacity from './Opacity.svelte';

    export let tacticalPlan: TacticalPlan;
    export let allTacticalPlans: TacticalPlanResponseType[] = [];
    export let onChange: (updatedPlans?: TacticalPlanResponseType[]) => void;
    export let willBeNextItem: boolean = false;
    export let disabled: boolean = false;
    export let clickedTacticalPlanId: number | null = null;

    let bitSum: number = 0;
    let clickedCheckbox: number = -1;

    function updateTacticalPlansWithSchedule(day: {
        id: number;
        translation: string;
        desc: string;
    }) {
        const id = tacticalPlan.getId();
        if (id === null) {
            alert('Tactical Plan not created yet');
            return;
        }

        const toggledWeekSchedule = WeekSchedule.toggle(day.id, bitSum);
        tacticalPlan.setWeekSchedule(toggledWeekSchedule);
        clickedCheckbox = day.id;

        // Bieżący plan jest zawsze pierwszym elementem — ważne dla onChange
        const allPatches: Promise<TacticalPlanResponseType>[] = [
            TacticalPlanApi.updateWeekSchedule(get(api), id, toggledWeekSchedule),
        ];

        // Jeśli włączamy dzień, zresetuj go w pozostałych planach — wszystko równolegle
        if (WeekSchedule.isChecked(day.id, toggledWeekSchedule)) {
            allTacticalPlans.forEach(plan => {
                if (plan.id !== id && plan.id !== null) {
                    allPatches.push(
                        TacticalPlanApi.updateWeekSchedule(
                            get(api),
                            plan.id,
                            WeekSchedule.reset(day.id, plan.week_schedule)
                        )
                    );
                }
            });
        }

        Promise.all(allPatches)
            .then(responses => {
                tacticalPlan.set(responses[0]);
                // Przekaż wszystkie odpowiedzi do rodzica — może zaktualizować lokalny stan
                // bez ponownego pobierania listy planów ani statystyk
                onChange(responses);
            })
            .catch(error => {
                alert('Error: ' + error.message);
            })
            .finally(() => {
                disabled = false;
            });
    }

    $: bitSum = tacticalPlan.getWeekSchedule();
    $: disabled = disabled;
</script>

<div class="container" class:disabled>
    {#each week as day, index}
        <div class="day">
            {#if clickedCheckbox === day.id && clickedTacticalPlanId === tacticalPlan.getId() && disabled}
                <IconPending spin={true} scale={0.5} />
            {:else if WeekSchedule.isChecked(day.id, bitSum)}
                <Opacity opacity={disabled ? 0.5 : 1}>
                    <IconRadioButtonChecked
                        on:click={() => {
                            if (disabled) return;
                            disabled = true;
                            clickedTacticalPlanId = tacticalPlan.getId();
                            updateTacticalPlansWithSchedule(day);
                        }}
                        scale={0.5}
                    />
                </Opacity>
            {:else}
                <Opacity opacity={disabled ? 0.5 : 1}>
                    <IconRadioButtonUnchecked
                        on:click={() => {
                            if (disabled) return;
                            disabled = true;
                            clickedTacticalPlanId = tacticalPlan.getId();
                            updateTacticalPlansWithSchedule(day);
                        }}
                        scale={0.5}
                    />
                </Opacity>
            {/if}
            {#if willBeNextItem}
                <div class="line-between-rows"></div>
            {/if}
        </div>
    {/each}
    {#if $debug}
        {tacticalPlan.getWeekSchedule()}
    {/if}
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        column-gap: 7px;
        width: 194px;
    }
    .day {
        position: relative;
    }
    .line-between-rows {
        position: absolute;
        border-bottom: 1px solid #888;
        width: 10px;
        left: 0;
        bottom: 0;
        transform: rotate(90deg) translate(8px, -3px);
        z-index: 1;
    }
    .disabled {
        pointer-events: none;
        /*opacity: 0.5;*/
        /*filter: brightness(1.5);*/
    }
</style>
